import React, { useEffect, useState } from 'react';
import { IonButton, IonIcon, IonGrid, IonRow, IonCol, IonLabel, IonText } from '@ionic/react';
import { sunnyOutline, moonOutline, desktopOutline } from 'ionicons/icons';
import { useTranslation } from 'react-i18next';
import { Theme, applyTheme, getInitialTheme } from '../utils/theme';

const ThemeToggle: React.FC = () => {
  const [theme, setTheme] = useState<Theme>(getInitialTheme());
  const { t } = useTranslation();

  useEffect(() => {
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)');

    const handleChange = () => {
      if (theme === 'system') {
        applyTheme('system');
      }
    };

    prefersDark.addEventListener('change', handleChange);
    applyTheme(theme);

    return () => {
      prefersDark.removeEventListener('change', handleChange);
    };
  }, [theme]);

  const handleThemeChange = (newTheme: Theme) => {
    setTheme(newTheme);
    applyTheme(newTheme);
  };

  return (
    <div>
      <h1 className="ml-4 text-xl font-bold pt-6 uppercase">{t('theme')}</h1>
      <IonGrid>
        <IonRow>
          {/* Light Mode */}
          <IonCol size="4" className="text-center">
            <IonButton
              onClick={() => handleThemeChange('light')}
              fill="clear"
              className={`h-40 sm:h-24 w-28 sm:w-32 text-black bg-white rounded-lg ${theme === 'light'
                ? 'border-blue-500 border-4'
                : ''
                }`}
            >
              <IonIcon icon={sunnyOutline} className="text-2xl" />
            </IonButton>
            <IonText className="block mt-2 text-sm">{t('light')}</IonText>
          </IonCol>

          {/* Dark Mode */}
          <IonCol size="4" className="text-center">
            <IonButton
              onClick={() => handleThemeChange('dark')}
              fill="clear"
              className={`h-40 sm:h-24 w-28 sm:w-32 text-white rounded-lg bg-gray-800 ${theme === 'dark'
                ? 'border-blue-500 border-4'
                : ''
                }`}
            >
              <IonIcon icon={moonOutline} className="text-2xl" />
            </IonButton>
            <IonText className="block mt-2 text-sm">{t('dark')}</IonText>
          </IonCol>

          {/* System Mode */}
          <IonCol size="4" className="text-center">
            <button
              onClick={() => handleThemeChange('system')}
              className={`h-40 sm:h-24 w-28 sm:w-32 relative overflow-hidden border-solid rounded-lg text-gray-500 ${theme === 'system'
                ? 'border-blue-500 border-4'
                : 'border-input border'
                }`}
            >
              <div className="absolute inset-0 flex">
                <div className="w-1/2 h-full bg-white"></div>
                <div className="w-1/2 h-full bg-gray-800"></div>
              </div>
              <IonIcon icon={desktopOutline} className="text-2xl relative z-10" />
            </button>
            <IonText className="block mt-2 text-sm">{t('system')}</IonText>
          </IonCol>
        </IonRow>
      </IonGrid>
    </div>
  );
};

export default ThemeToggle;